module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Design/Crop-96cf3bf7dd77aa3b99bd604de882098a.svg";